import {hoistCmp, uses} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {form} from '@xh/hoist/cmp/form';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {numberInput, textArea, textInput} from '@xh/hoist/desktop/cmp/input';
import {filler, hbox, img, vframe} from '@xh/hoist/cmp/layout';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {CompanyEditModel} from './CompanyEditModel';

export const companyEdit = hoistCmp.factory<CompanyEditModel>({
    model: uses(CompanyEditModel),
    render({model}) {
        return panel({
            tbar: toolbar({
                compact: true,
                items: [
                    'Company Profile',
                    filler(),
                    button({
                        icon: Icon.check(),
                        intent: 'success',
                        tooltip: 'Save',
                        disabled: !(model.isVlid && model.hasChanges),
                        onClick: () => model.save()
                    }),
                    button({
                        icon: Icon.undo(),
                        intent: 'warning',
                        tooltip: 'revert',
                        disabled: !(model.isVlid && model.hasChanges),
                        onClick: () => model.revert()
                    })
                ]
            }),
            item: editForm()
        });
    }
});

const editForm = hoistCmp.factory<CompanyEditModel>(({model}) => {
    const imgUrl = model.company.logoUrl;

    return vframe({
        className: 'security-edit-form',
        item: form({
            fieldDefaults: {
                inline: true,
                minimal: true,
                commitOnChange: true,
                labelTextAlign: 'right',
                labelWidth: 100
            },
            items: [
                formField({field: 'description', item: textArea({height: 100})}),
                hbox(formField({field: 'ceo', item: textInput()}), formField({field: 'employees', item: numberInput()})),

                hbox(
                    formField({field: 'logoUrl', flex: 1, item: textInput()}),
                    img({
                        className: 'security-edit-form__image',
                        src: imgUrl
                    })
                ),

                formField({field: 'address', item: textInput()}),
                formField({field: 'city', item: textInput()}),
                hbox(formField({field: 'state', item: textInput()}), formField({field: 'zip', item: textInput()}))
            ]
        })
    });
});
